<template>
  <div class="property-input">
    <label class="property-label">
      {{ property.text ? property.text : property.name }}
      <Tooltip v-if="property.tooltip" :text="property.tooltip" />
    </label>
    <div class="property-path-wrapper">
      <div class="selected-resource" @click="togglePopup">
        <img v-if="selectedResource && property.ressourceType == 'image'" :src="selectedResource.url" :alt="selectedResource.description" class="resource-preview" />
        <video v-else-if="selectedResource && property.ressourceType == 'video'" :src="selectedResource.url" :alt="selectedResource.description" class="resource-preview" />
        <span v-else class="no-resource">Aucune ressource sélectionnée</span>
      </div>
    </div>
    <ResourceSelectionPopup
      :show="showPopup"
      :selectedResourcePath="element"
      :ressourceType="property.ressourceType"
      @close="togglePopup"
      @select="selectRessource"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import ResourceSelectionPopup from "../PopupComponents/ResourceSelectionPopup.vue"
import Tooltip from "../Tooltip.vue";

export default {
  name: 'PathInput',
  components: {
    ResourceSelectionPopup,
    Tooltip
  },
  props: {
    property: {
      type: Object,
      required: true
    },
    element: {
      type: String,
      required: true
    },
    container: {
      type: Object,
      required: true
    },
    eventOnChangeRessource: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      showPopup: false
    };
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      "ressourceByPath"
    ]),
    selectedResource() {
      return this.ressourceByPath(this.element);
    }
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'updateProperty': actions.UPDATE_PROPERTY,
    }),
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
    selectRessource(ressource) {
      if (this.eventOnChangeRessource) {
        this.$emit('eventOnChangeRessource', ressource);
      }
      else {
        this.updateProperty({
          element: this.container,
          property: this.property,
          value: ressource.idSoft
        });
      }
    }
  }
}
</script>

<style scoped>
.property-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.25rem;
  font-size: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
}

.property-label {
  font-size: 1rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 1);
  color: #e5e7eb;
  display: flex;
  justify-content: space-between;
}

.property-path-wrapper {
  display: flex;
  gap: 0.5rem;
  flex: 1;
}

.selected-resource {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: center;
}

.selected-resource:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: #3b82f6;
}

.resource-preview {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 0.25rem;
}

.no-resource {
  color: #9ca3af;
  font-style: italic;
}

.property-path-button {
  padding: inherit;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.25rem;
  color: #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
}

.property-path-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: #3b82f6;
}

.property-path-button:focus {
  outline: none;
  border-color: #3b82f6;
  background-color: rgba(255, 255, 255, 0.15);
}

.loader {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.property-path-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
